type WalmartOnlineProductData = {
  msrp: number;
  currentPrice: number;
  currentPrices: number[];
  url: string;
  sku: string;
  lastUpdated: number;
  lastUpdates: number[];
  discountPercentage: number;
};

export const buildWalmartOnlinePayload = (input: {
  productId: string;
  productName: string;
  productImage?: string;
  productCategory?: string;
  walmartOnlineData: WalmartOnlineProductData;
}) => {
  return {
    upc: input.productId,
    title: input.productName,
    image: input.productImage || "",
    category: input.productCategory || "",
    ...input.walmartOnlineData,
  };
};

export const buildFavoritePayload = (input: {
  productId: string;
  productName: string;
  productImage?: string;
  productCategory?: string;
  productStoreId?: string;
  onlinePrice?: number;
  storePrice?: number;
  stock?: number;
}) => {
  return {
    upc: input.productId,
    name: input.productName,
    image: input.productImage || "",
    category: input.productCategory || "",
    storeId: input.productStoreId || "",
    // Snapshot at save time so the favorite can show the discount/stock it was saved at.
    ...(input.onlinePrice && input.onlinePrice > 0 ? { onlinePrice: input.onlinePrice } : {}),
    ...(input.storePrice && input.storePrice > 0 ? { storePrice: input.storePrice } : {}),
    ...(input.stock && input.stock > 0 ? { stock: input.stock } : {}),
  };
};

export const getIsActionLoading = (flags: {
  addPending: boolean;
  addOnlinePending: boolean;
  removePending: boolean;
}) => {
  return flags.addPending || flags.addOnlinePending || flags.removePending;
};
